import { render, staticRenderFns } from "./import-ledgers.vue?vue&type=template&id=861fe85a"
import script from "./import-ledgers.ts?vue&type=script&lang=js&external"
export * from "./import-ledgers.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports